class GiftCardOptions extends HTMLElement {
  constructor() {
    super();
    this.amount = this.querySelector("input[data-amount]:checked").value;
    this.sendToRecipient = this.querySelector("[data-send-gift-card-to-recipient]");
    this.design = this.querySelector("[data-gift-card-design]");
    this.recipientName = this.querySelector("[data-gift-card-recipient-toName]");
    this.recipientEmail = this.querySelector("[data-gift-card-recipient-email]");
    this.fromName = this.querySelector("[data-gift-card-recipient-from-name]");
    this.from = this.querySelector("[data-gift-card-recipient-from]");
    this.subject = this.querySelector("[data-gift-card-recipient-subject]");
    this.message = this.querySelector("[data-gift-card-recipient-message]");

    this.previewBtn = this.querySelector("[data-gift-card-preview]");
    this.previewTemplate = this.querySelector("[data-gift-card-preview-template]");

    this.setEventListeners();

    window.addEventListener("load", () => {
      this.handleImages(true);
    });
  }

  setEventListeners() {
    this.previewBtn.addEventListener("click", this.createPreview.bind(this));
    this.addEventListener("change", this.onChange.bind(this));
  }

  createPreview() {
    let popup = this.previewTemplate.innerHTML;
    popup = popup.replace(/{{design}}/g, this.design.value);
    popup = popup.replace(/{{recipientName}}/g, this.recipientName.value);
    popup = popup.replace(/{{email}}/g, this.recipientEmail.value);
    popup = popup.replace(/{{fromName}}/g, this.fromName.value);
    popup = popup.replace(/{{from}}/g, this.from.value);
    popup = popup.replace(/{{message}}/g, this.message.value ? `&quot;${this.message.value}&quot;` : "");
    popup = popup.replace(/{{amount}}/g, this.amount);

    document.body.insertAdjacentHTML("beforeend", popup);
  }

  onChange(event) {
    event.stopPropagation();
    if (event.target.type === "radio") {
      this.onOptionsChange(event);
    } else {
      this.onRecipientFormChange(event);
    }
  }

  onRecipientFormChange(event) {
    this.sendToRecipient.checked = !!this.recipientEmail.value.trim();
  }

  onOptionsChange(event) {
    let currentIndex = -1;
    const swiperEl = document.querySelector(".product-single__thumbnails .swiper-container");
    const slides = swiperEl.querySelectorAll(".swiper-slide");
    slides.forEach((slide, index) => {
      if (slide.classList.contains("swiper-slide-active")) {
        currentIndex = index;
      }
    });
    const targetListId = event.target.name;
    const select = document.getElementById(targetListId);
    select.value = event.target.value;
    if (event.target.dataset.design) {
      this.design.value = event.target.dataset.design;
    } else if (event.target.dataset.amount) {
      this.amount = event.target.value;
    }
    select.dispatchEvent(new Event("change"));

    setTimeout(() => this.handleImages(event.target.dataset.design, currentIndex), 0);
  }

  handleImages(isDesign, currentIndex = -1) {
    const swiperEl = document.querySelector(".product-single__thumbnails .swiper-container");
    const swiper = swiperEl.swiper;
    if (!swiper) return;
    window.swiper = swiper;

    const slides = swiperEl.querySelectorAll(".swiper-slide");

    let activeIndex = -1;
    const url = new URL(window.location.href);
    const variantID = url.searchParams.get("variant");

    const setActiveSlideByDesign = (slide, index) => {
      const isCurrentSlide = slide.dataset.variantsWithThisMedia.includes(variantID);
      const isActive = slide.classList.contains("swiper-slide-active");
      if (isCurrentSlide && !isActive) {
        activeIndex = index;
      }
    };

    const preventSlideChange = () => {
      activeIndex = currentIndex;
    };

    slides.forEach(isDesign ? setActiveSlideByDesign : preventSlideChange);

    if (activeIndex !== -1) {
      swiper.slideTo(activeIndex);
    }
  }
}

customElements.define("gift-card-options", GiftCardOptions);
